module.exports = __webpack_public_path__ + "static/man-20-engineering-the-alpha-f87a5f69df669efa42a4d64b68af3db2.jpg";